import { render, staticRenderFns } from "./ArquivosDadosUploadedFilesList.vue?vue&type=template&id=70155fc8&"
import script from "./ArquivosDadosUploadedFilesList.vue?vue&type=script&lang=js&"
export * from "./ArquivosDadosUploadedFilesList.vue?vue&type=script&lang=js&"
import style0 from "./ArquivosDadosUploadedFilesList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VDataTable,VDivider,VIcon,VTextField,VTooltip})
